import React from 'react';
import '@dotlottie/player-component';
import { useIntl } from 'react-intl';
import { Button } from '@whitelabel/component-library';
import { ReactComponent as CrossIcon } from '@whitelabel/media/icons/small/cross.svg';
import commonMessages from '@whitelabel/helpers/messages/commonMsg';
import contactConfirmLottie from '@whitelabel/xcover-shared/media/lotties/contact-confirm.lottie';
import { StyledLottie, StyledModal } from '@whitelabel/xcover-shared/styled/StyledContactConfirmModal';
import contactModalMsg from '@whitelabel/xcover-shared/helpers/messages/contactModalMsg';

interface IContactConfirmModalProps {
  toggleModalClose: () => void;
  isOpen: boolean;
}

const ContactConfirmModal = ({ toggleModalClose, isOpen }: IContactConfirmModalProps): JSX.Element => {
  const { formatMessage } = useIntl();

  const body = (
    <>
      <div>
        <h1 className="h1">{formatMessage(contactModalMsg.contactSuccessTitle)}</h1>
        <p className="subtext">{formatMessage(contactModalMsg.contactSuccessText)}</p>
      </div>
      <StyledLottie>
        <dotlottie-player src={contactConfirmLottie} autoplay loop />
      </StyledLottie>
    </>
  );

  return (
    <StyledModal
      header={' '}
      body={body}
      footer={
        <Button buttonType="secondary" onClick={toggleModalClose} icon={CrossIcon}>
          {formatMessage(commonMessages.closeButtonText)}
        </Button>
      }
      isOpen={isOpen}
      toggle={toggleModalClose}
      centered
    />
  );
};

export default ContactConfirmModal;
